import { ChevronLeft, ChevronRight } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import type { CSSProperties, LegacyRef, ReactNode } from 'react'

import classes from './styles.module.scss'

type HorizontalScrollWebProps = {
  showArrows: boolean
  className: string
  classNameContainer: string
  linesAmount?: number
  wrapperRef: LegacyRef<HTMLDivElement>
  scrollRef: LegacyRef<HTMLDivElement>
  prevScroll: () => void
  nextScroll: () => void
  children: ReactNode
  styleContainer?: CSSProperties
  'data-test'?: string
  with3DImage?: boolean
}

function HorizontalScrollWeb(props: HorizontalScrollWebProps) {
  const {
    wrapperRef,
    scrollRef,
    prevScroll,
    nextScroll,
    className,
    classNameContainer,
    showArrows,
    children,
    linesAmount,
    with3DImage,
  } = props

  return (
    <div
      className={cx(classes.scrollWrap, with3DImage && classes.scrollWrap3D, className)}
      ref={wrapperRef}
      data-test={props?.['data-test']}
    >
      {showArrows && (
        <>
          <ChevronLeft
            onClick={prevScroll}
            className={cx(
              classes.scrollButton,
              classes.scrollButtonPrev,
              classes[`lines-amount-${linesAmount}`],
              'game-icon-prev',
            )}
          />
          <ChevronRight
            onClick={nextScroll}
            className={cx(
              classes.scrollButton,
              classes.scrollButtonNext,
              classes[`lines-amount-${linesAmount}`],
              'game-icon-next',
            )}
          />
        </>
      )}

      <div style={props.styleContainer} className={cx(classes.scrollContainer, classNameContainer)} ref={scrollRef}>
        {children}

        {/* margin-right wasn't applied for last card */}
        {/* <div className={classes.tail} /> */}
      </div>
    </div>
  )
}

export default HorizontalScrollWeb
